import { canMessageExtension, pingExtension } from './extension-messaging';

export class ExtensionDetector {
  private static TIMEOUT_MS = 1000;
  private static MESSAGE_TYPE = 'EXTENSION_DETECT';
  private static RESPONSE_TYPE = 'EXTENSION_DETECT_RESPONSE';
  private static inFlight: Promise<boolean> | null = null;

  /**
   * Detects if the specific extension is installed and ready
   * @returns Promise<boolean>
   */
  static async isExtensionInstalled(): Promise<boolean> {
    if (this.inFlight) return this.inFlight;

    // On app.clugtm.com the extension's content script doesn't run, but the
    // extension takes messages from the page directly.
    const check = canMessageExtension()
      ? pingExtension(this.TIMEOUT_MS).then(
          (answered) => answered || this.handshake()
        )
      : this.handshake();
    this.inFlight = check;
    try {
      return await check;
    } finally {
      if (this.inFlight === check) this.inFlight = null;
    }
  }

  private static handshake(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const timeoutId = setTimeout(() => {
        cleanup();
        resolve(false);
      }, this.TIMEOUT_MS);

      const messageHandler = (event: MessageEvent) => {
        if (
          event.source === window &&
          event.origin === window.location.origin &&
          event.data?.type === this.RESPONSE_TYPE
        ) {
          cleanup();
          resolve(true);
        }
      };

      window.addEventListener('message', messageHandler);

      const cleanup = () => {
        clearTimeout(timeoutId);
        window.removeEventListener('message', messageHandler);
      };

      window.postMessage({ type: this.MESSAGE_TYPE }, window.location.origin);
    });
  }
}
